const language = {
  props: {
    className: "language-JS",
    classNameSubmenuDropdown: "menu-content-dropdown-js",
    classNameSubmenuDropdownList: "menu-content-dropdown-list-js",
    classNameSubmenuDropdownItem: "menu-content-dropdown-item-js",
    classNameAssociateSelect: "menu-content-associate-select",
    classNameAssociateSelectOption: "language-option",
    classNameSubmit: "menu-content-submit-js",
    dataLanguageLayout: "data-language-layout",
    selectorLanguageOptions: ".c-megamenu__submenu-language .c-locale-form__languages .c-locale-form__languages-option-JS input",
    $lastItem: null,
    langList: null,
  },

  init: function (baseDom) {
    const baseFind = baseDom ? baseDom : document,
      items = baseFind.getElementsByClassName(this.props.className);
    for (let k = 0; k < items.length; k++) {
      this.initLogic(items[k]);
      this.hideIfNeeded(items[k]);
    }

    if (items) {
      const $meta = document.querySelector("body").dataset.langUrl;
      if ($meta) {
        bcl.ajax.getRequest(null, $meta, this.initAlternateLang.bind(this), items);
        const localeConfigurationUrl = document.querySelector("body").dataset.langUrl.replace("alternateLang", "localeConfigurationLang");
        bcl.ajax.getRequest(null, localeConfigurationUrl, this.populatePopoverLang.bind(this));
      }
    }

    this.initLanguageOptionEvents();
  },

  initAlternateLang: function (response, items) {
    if (response && response.response) {
      try {
        this.props.langList = JSON.parse(response.response);
      } catch (e) {
        console.error(e);
        console.warn("Error on initAlternateLang");
        this.props.langList = null;
      }
      if (this.props.langList && this.props.langList.pages) {
        const container = document.createElement("div");
        container.classList.add("hidden", "alternateLang-JS");
        bcl.u.forEach(this.props.langList.pages, function (page) {
          const child = document.createElement("div");
          child.classList.add("references-JS");
          child.dataset.hreflang = page.languageCode.toLowerCase();
          child.dataset.href = language.decodeURL(page.url);
          container.appendChild(child);
        });
        bcl.u.forEach(items, function (item) {
          if (item.parentElement && item.parentElement.parentElement) {
            const clone = container.cloneNode(true);
            item.appendChild(clone);
          }
        });
        this.checkRedirect();
        setTimeout(function () {
          window.dispatchEvent(new CustomEvent("loaded-language"));
        }, 1000);
      }
    }
  },
  decodeURL: (url) => {
    if (url?.includes("%")) {
      return decodeURI(url);
    }
    return url;
  },
  populatePopoverLang: function (response) {
    const containerForm = document.querySelector(".formLanguageContainer-JS");
    if (response && response.response) {
      try {
        this.props.langList = JSON.parse(response.response);
      } catch (e) {
        console.error(e);
        console.warn("Error on populatePopoverLang");
        this.props.langList = null;
      }
      if (this.props.langList && this.props.langList.pages) {
        bcl.u.forEach(this.props.langList.pages, function (page) {
          const label = document.createElement("label");
          label.classList.add("c-fieldset__row", "c-fieldset__form-radio", "c-locale-form__languages-option-JS");
          const input = document.createElement("input");
          input.name = "language_page";
          input.type = "radio";
          input.value = language.decodeURL(page.url);
          input.checked = page.currentLanguage;
          input.dataset.hreflang = page.languageCode.toLowerCase();
          const span = document.createElement("span");
          span.classList.add("c-locale-form__languages-language");
          span.textContent = page.languageLabel;
          label.appendChild(input);
          label.appendChild(span);
          containerForm.appendChild(label);
        });

        setTimeout(function () {
          window.dispatchEvent(new CustomEvent("loaded-language"));
        }, 1000);

        const currentLanguage = document.querySelector(".c-locale-form__languages-option-JS input:checked");
        const currentLanguageText = document.querySelector(".language-current-JS span");
        if (currentLanguage && currentLanguageText) {
          currentLanguageText.innerHTML = currentLanguage.nextElementSibling.textContent;
        }
      }
    }
    document.querySelectorAll('link[rel="translate"]').forEach(function ($lang) {
      const $option = document.createElement("div");
      $option.innerHTML = `<label class="c-fieldset__row c-fieldset__form-radio c-locale-form__languages-option-JS">
                <input type="radio" data-translation-enabled="true" data-hreflang="${$lang.dataset.code}" name="language_page" value="${$lang.dataset.code}" data-label="${$lang.dataset.label}"/>
                <span class="c-locale-form__languages-language">${$lang.dataset.label}</span>
            </label>`;
      containerForm.appendChild($option.children[0]);
    });
    this.initLanguageOptionEvents();
  },

  initLogic: function ($component) {
    this.props.$container = $component;

    this.updateLanguageURLs($component);

    this.addDropdownInSubmenu($component);

    this.addAssociatedSelect($component);

    this.addSubmitButton($component);

    this.loadCurrentMarket($component);

    this.initIconAndLabels($component);
  },

  hideIfNeeded: function ($item) {
    const langLayout = $item.getAttribute("data-language-layout");
    if (!langLayout || langLayout === "full") {
      return;
    }
    if (langLayout === "market") {
      const $lang = $item.querySelector(".selector-language-JS");
      if ($lang) {
        bcl.u.addClass($lang, "hidden");
      }
    } else if (langLayout === "lang") {
      const $country = $item.querySelector(".selector-country-JS");
      if ($country) {
        bcl.u.addClass($country, "hidden");
      }
    }
  },

  showIfNeeded: function ($item) {
    const langLayout = $item.getAttribute("data-language-layout");
    if (!langLayout || langLayout === "full") {
      const $lang = $item.querySelector(".selector-language-JS");
      if ($lang) {
        bcl.u.removeClass($lang, "hidden");
      }
      const $country = $item.querySelector(".selector-country-JS");
      if ($country) {
        bcl.u.removeClass($country, "hidden");
      }
    }
    if (langLayout === "market") {
      const $lang = $item.querySelector(".selector-country-JS");
      if ($lang) {
        bcl.u.removeClass($lang, "hidden");
      }
    } else if (langLayout === "lang") {
      const $country = $item.querySelector(".selector-language-JS");
      if ($country) {
        bcl.u.removeClass($country, "hidden");
      }
    }
  },

  initIconAndLabels: function ($container) {
    const $iconCurrentCountry = $container.querySelector("li[data-current-country] span");
    if ($iconCurrentCountry) {
      const spanIcon = $container.parentElement.parentElement.querySelector(".lang-flag-JS");
      if (spanIcon) {
        bcl.u.addClass(spanIcon, $iconCurrentCountry.classList.value);
      }
    }
  },

  updateLanguageURLs: function ($item) {
    const $associateSelect = $item.getElementsByClassName(this.props.classNameAssociateSelect);
    let $options, $url, datahpcode;

    if (!$associateSelect && !$associateSelect[0]) {
      return;
    }

    for (let i = 0; i < $associateSelect.length; i++) {
      $options = $associateSelect[i].getElementsByTagName("option");
      if ($options && $options[0]) {
        for (let j = 0; j < $options.length; j++) {
          datahpcode = $options[j].getAttribute("data-hp-code");
          if (datahpcode) {
            $url = document.querySelector(".references-JS[data-hreflang='" + datahpcode.toLowerCase() + "']");
            if ($url) {
              $options[j].setAttribute("data-url", $url.getAttribute("data-href"));
            }
          }
        }
      }
    }
  },

  initDialog: function (open) {
    const $containerLanguageDialog = document.getElementsByClassName("language-dialog-container-JS")[0];
    let $containerRibbonLanguage;

    if ($containerLanguageDialog && $containerLanguageDialog.closest(".ribbon-language-JS")) {
      $containerRibbonLanguage = $containerLanguageDialog.closest(".ribbon-language-JS").parentNode;
    }

    const ribbonLangLocalStorage = localStorage.getItem("barcelo_languageRibbon");
    const navCookie = bcl.cookie.get("bhg_keep_nav");
    const redirect = bcl.u.getParameterByName("redirect");

    if (!open && !redirect && (!navCookie || !ribbonLangLocalStorage) && bcl.contextHub && !bcl.editMode) {
      const profile = bcl.contextHub.get("profile");
      if (profile) {
        const countryCode = bcl.contextHub.getItem(profile, "country_code");
        if (countryCode) {
          const $associateSelect = document.querySelector("." + this.props.classNameAssociateSelect + "[data-country=" + countryCode.toLowerCase() + "]");
          if ($associateSelect && $containerLanguageDialog) {
            const $currentCountry = document.querySelector("." + this.props.classNameSubmenuDropdownItem + "[data-current-country=true]");
            if ($currentCountry) {
              const currentCountry = $currentCountry.getAttribute("data-country");
              if (currentCountry && currentCountry.toLowerCase() !== countryCode.toLowerCase()) {
                open = true;
              }
            }
          }
        }
      }
    }

    if (open) {
      if ($containerRibbonLanguage) {
        const $divInsideMainContainer = document.querySelector("main.root > div > div.iparsys"),
          $ribbonLanguageElement = this.insertAsideToDiv($containerRibbonLanguage);
        if ($ribbonLanguageElement && $divInsideMainContainer) {
          $divInsideMainContainer.appendChild($ribbonLanguageElement);

          if (bcl.c.ribbon?.language?.props.open) {
            bcl.c.ribbon.language.props.open = true;
          }
        }
      } else if (!$containerRibbonLanguage) {
        bcl.modal.openModal($containerLanguageDialog);
      }
    }
  },

  insertAsideToDiv: function ($element) {
    let ribbonDivExisted = document.querySelector("main.root > div > div.iparsys .ribbon-language.ribbon");

    if (ribbonDivExisted) {
      return;
    }

    bcl.u.addClass($element, "ribbon section");
    ribbonDivExisted = $element;

    return ribbonDivExisted;
  },

  addDropdownInSubmenu: function ($item) {
    const $dropDownSubmenu = $item.getElementsByClassName(this.props.classNameSubmenuDropdown);

    if ($dropDownSubmenu && $dropDownSubmenu[0]) {
      $dropDownSubmenu[0].addEventListener("click", () => {
        const $dropdown = $item.getElementsByClassName(this.props.classNameSubmenuDropdownList);
        if ($dropdown && $dropdown[0]) {
          this.clickDropDown($dropdown[0]);
        }
      });
    }

    const $dropdown = $item.getElementsByClassName(this.props.classNameSubmenuDropdownList);
    if ($dropdown && $dropdown[0]) {
      this.props.$dropdown = $dropdown[0];

      const $dropdownItems = $dropdown[0].getElementsByClassName(this.props.classNameSubmenuDropdownItem);
      if (!$dropdownItems) {
        return;
      }

      for (let k = 0; k < $dropdownItems.length; k++) {
        $dropdownItems[k].addEventListener("click", () => {
          this.clickDropDownItem($dropDownSubmenu[0]);
          bcl.u.removeClass($dropdown[0], bcl.c.header.props.classNameActive);
        });

        $dropdownItems[k].addEventListener("click-js-input", () => {
          this.clickDropDownItem($dropDownSubmenu[0], "fromJS");
          bcl.u.removeClass($dropdown[0], bcl.c.header.props.classNameActive);
        });
      }

      if ($dropdownItems[0]) {
        // Trigger
        const event = document.createEvent("HTMLEvents");
        event.initEvent("click-js-input", true, false);
        $dropdownItems[0].dispatchEvent(event);
      }
    }
    const currentLanguage = document.querySelector(".c-locale-form__languages-option-JS input:checked");
    const currentLanguageText = document.querySelector(".language-current-JS span");
    if (currentLanguage && currentLanguageText) {
      currentLanguageText.innerHTML = currentLanguage.nextElementSibling.textContent;
    }
  },

  addAssociatedSelect: function ($item) {
    const $associateSelect = $item.getElementsByClassName(this.props.classNameAssociateSelect);
    const $submitButton = $item.getElementsByClassName(this.props.classNameSubmit);
    bcl.u.hiddeElements($submitButton);

    let option = null;

    if ($associateSelect && $associateSelect[0]) {
      for (let i = 0; i < $associateSelect.length; i++) {
        const hpcode = localStorage.getItem("barcelo_language");
        if (hpcode && !option) {
          option = $associateSelect[i].querySelector("option[data-hp-code='" + hpcode.toLocaleLowerCase() + "']");
        }
        $associateSelect[i].addEventListener("change", (event) => {
          const $eventItem = event.target || event.srcElement;
          this.changeAssociatedSelect($eventItem, null, $submitButton, true);
        });
      }
    }

    setTimeout(function () {
      const langUrl = document.body.dataset.langUrl;
      if (!option || option.getAttribute("selected") || option.selected || !langUrl || langUrl.includes("404")) {
        return;
      }

      const select = option.parentElement;
      window.addEventListener("loaded-language", () => {
        if (!bcl.u.containsClass(select, "hidden")) {
          this.changeAssociatedSelect(select, option, $submitButton, false);
        }
      });
    }, 100);
  },

  changeAssociatedSelect: function ($item, $option, $submitButton, redirect) {
    if (!$item) {
      return;
    }
    if (!$option) {
      $option = bcl.u.getSelectedOption($item);
    }
    const data = {};
    if ($option) {
      const hpcode = $option.getAttribute("data-hp-code");
      data.hpcode = hpcode;
      data.label = $option.label;
      data.currentHpcode = bcl.u.getSelectedOption($item).getAttribute("data-hp-code");
      data.currentLabel = bcl.u.getSelectedOption($item).label;
      const $url = document.querySelector(".references-JS[data-hreflang='" + hpcode.toLowerCase() + "']");
      if ($url) {
        $submitButton[0].setAttribute("data-url", $url.getAttribute("data-href"));
      }
    }
    this.executeSubmit($submitButton[0], redirect, data);
  },

  addSubmitButton: function ($item) {
    const $submitButton = $item.getElementsByClassName(this.props.classNameSubmit);
    if ($submitButton && $submitButton[0]) {
      $submitButton[0].addEventListener("click", () => {
        this.executeSubmit(this, true);
      });
    }
  },

  executeSubmit: function ($submitButton, redirect, data) {
    redirect = redirect ? redirect : false;
    const link = $submitButton.getAttribute("data-url");
    const url = new URL(link);
    if (link) {
      const targetPath = "/" + url.pathname.split("/")[1];
      if (redirect) {
        bcl.u.addBhgLoading();
        bcl.cookie.set("bhg_keep_nav", true, { path: targetPath });
        if (data && data.hpcode) {
          localStorage.setItem("barcelo_language", data.hpcode);
        }
        location.href = link + window.location.search;
      } else {
        bcl.c.ribbon?.language?.init(document, data);
      }
    }
  },

  clickDropDown: function ($item) {
    bcl.u.toggleClass($item, bcl.c.header.props.classNameActive);
    let $search = null;

    if ($item && $item.parentNode && $item.parentNode.parentNode) {
      $search = $item.parentNode.parentNode.querySelector(".dropdownSearch-JS");
    }

    if ($search) {
      $search.focus();
    }
  },

  clickDropDownItem: function ($selectOption, fromJs) {
    const $item = event.currentTarget || event.srcElement;
    $selectOption.value = $item.getAttribute("data-value");
    $selectOption.text = $item.getAttribute("data-value");

    const icon = $item.getAttribute("data-icon");
    bcl.u.removeClassWithRegex($selectOption, new RegExp(/^flag-icon/g));
    bcl.u.addClass($selectOption, icon);

    const $associateSelect = document.getElementsByClassName(this.props.classNameAssociateSelect);
    this.filterAssociateSelect($item, $associateSelect);
    $item.closest("form").getElementsByClassName(this.props.classNameSubmit);
    if (!fromJs) {
      const $submitButton = $item.closest("form").getElementsByClassName(this.props.classNameSubmit);
      $submitButton[0].click();
    }
  },

  filterAssociateSelect: function ($item, $associateSelect) {
    const $submitButton = $item.closest("form").getElementsByClassName(this.props.classNameSubmit),
      $submitButtonParent = $submitButton[0].closest(".c-fieldset");
    let $options, $select;

    for (let i = 0; i < $associateSelect.length; i++) {
      if ($item.getAttribute("data-country") === $associateSelect[i].getAttribute("data-country")) {
        $select = $associateSelect[i];

        bcl.u.removeClass($select, "hidden");
        $options = $select.getElementsByTagName("option");

        if ($options.length === 1) {
          $select.setAttribute("disabled", "disabled");
        }

        if ($options && $options[0]) {
          const hpcode = $options[0].getAttribute("data-hp-code");
          if (hpcode) {
            const $url = document.querySelector(".references-JS[data-hreflang='" + hpcode.toLowerCase() + "']");
            if ($url) {
              $submitButton[0].setAttribute("data-url", $url.getAttribute("data-href"));
            } else {
              $submitButton[0].setAttribute("data-url", window.location.protocol + "//" + window.location.host + "/" + hpcode.toLowerCase());
            }
          }
        }
      } else {
        bcl.u.addClass($associateSelect[i], "hidden");
      }
    }

    if (!$select) {
      return;
    }

    const $associateSelectParent = $select.closest(".selector-language-JS");

    if (!$associateSelectParent.classList.contains("hidden-JS")) {
      if ($select.children.length > 1) {
        bcl.u.removeClass($associateSelectParent, "hidden");
        bcl.u.removeClass($submitButtonParent, "pt-5");
      } else {
        bcl.u.addClass($associateSelectParent, "hidden");
        bcl.u.addClass($submitButtonParent, "pt-5");
      }
    }
  },

  loadCurrentMarket: function ($item) {
    const $dropdown = $item.getElementsByClassName(this.props.classNameSubmenuDropdownList);

    if ($dropdown && $dropdown[0]) {
      const $dropdownItems = $dropdown[0].getElementsByClassName(this.props.classNameSubmenuDropdownItem);
      if ($dropdownItems) {
        for (let i = 0; i < $dropdownItems.length; i++) {
          if ($dropdownItems[i].getAttribute("data-current-country")) {
            const event = document.createEvent("HTMLEvents");
            event.initEvent("click-js-input", true, false);
            $dropdownItems[i].dispatchEvent(event);
          }
        }
      }
    }

    const $select = $item.getElementsByClassName(this.props.classNameAssociateSelect);

    let langSelected = -1;
    if ($select) {
      for (let i = 0; i < $select.length; i++) {
        const $selectItems = $select[i].getElementsByClassName(this.props.classNameAssociateSelectOption);
        if ($selectItems) {
          for (let j = 0; j < $selectItems.length; j++) {
            if ($selectItems[j].getAttribute("data-current-language")) {
              $selectItems[j].selected = true;
              langSelected = $selectItems.length;
            }
          }
        }
      }
    }
    const langLayout = $item.getAttribute("data-language-layout");
    if (langSelected < 2 && langLayout && langLayout === "lang") {
      this.removeClickEventFromCurrentMegaMenu($item);
    }
  },

  removeClickEventFromCurrentMegaMenu: function ($item) {
    const $span = $item.querySelector(".language-current-JS");
    if ($span) {
      bcl.u.addClass($span.parentNode, "block-tab-event");
      bcl.u.addClass($span.parentNode, "cursor-default");
    } else {
      const $div = $item.querySelector(".language-selection");
      if ($div) {
        bcl.u.addClass($div, "block-tab-event");
        bcl.u.addClass($div, "cursor-default");
      }
    }
  },

  checkRedirect: function () {
    const redirect = bcl.u.getParameterByName("redirect");
    if (redirect && redirect === "true") {
      const lang = bcl.u.getParameterByName("lang");
      if (lang) {
        const localeConfigurationUrl = document.querySelector("body").dataset.langUrl.replace("alternateLang", "localeConfigurationLang");
        bcl.ajax.getRequest(null, localeConfigurationUrl, this.checkLang.bind(this));
      } else {
        languageDialog.initTargetItem(document.getElementById(languageDialog.props.classTargetLanguage));
        const url = window.location.href;
        if (languageDialog.props.targetUrl) {
          const queryParams = bcl.u.removeUrlParameter("redirect", url);
          if (queryParams) {
            window.location = languageDialog.props.targetUrl.split("?")[0] + "?" + queryParams;
          } else {
            window.location = languageDialog.props.targetUrl.replace("?redirect=true", "");
          }
        }
      }
    } else {
      bcl.contextHub.callWhenReady(bcl.c.ribbon?.language?.init.bind(bcl.c.ribbon?.language), bcl.contextHub.props.nameProfile);
    }
  },

  checkLang: function (response) {
    if (response && response.response) {
      try {
        const redirectData = JSON.parse(response.response);
        if (redirectData) {
          const redirect = bcl.u.getParameterByName("redirect") === "true";
          const lang = bcl.u.getParameterByName("lang") === "true";
          let matchedPages;
          if (redirect && lang) {
            matchedPages = this.matchPagesByDeviceLang(redirectData);
          } else if (redirect) {
            matchedPages = this.matchPagesByUsersCountry(redirectData);
          }
          if (matchedPages && matchedPages.length) {
            window.location.href = matchedPages[0].url;
          }
        }
      } catch (e) {
        console.warn("Error on checkLang", e);
      }
    }
  },

  matchPagesByDeviceLang: function (redirectData) {
    const currentPageLanguage = document.querySelector("html")?.lang?.replace(/-[A-Z]{2}$/, "");
    const deviceLanguage = navigator.language?.replace(/-[A-Z]{2}$/, "");
    const currentPageCountry = document.querySelector("html")?.lang?.replace(/^[a-z]{2}-/, "");
    const targetLang = `${deviceLanguage}-`;
    if (currentPageLanguage && deviceLanguage && currentPageCountry && currentPageLanguage !== deviceLanguage) {
      let matchedPages = redirectData.pages.filter((page) => page.languageCode.startsWith(targetLang) && page.isDefaultLanguagePage);
      if (!matchedPages.length) {
        matchedPages = redirectData.pages.filter((page) => page.languageCode.startsWith(targetLang));
      }
      return matchedPages;
    }
  },

  matchPagesByUsersCountry: function (redirectData) {
    const usersCountry = bcl.contextHub.getItem("profile", "country_code");
    const currentPageCountry = document.querySelector("html")?.lang?.replace(/^[a-z]{2}-/, "");
    if (usersCountry && usersCountry !== currentPageCountry) {
      const targetCountry = `-${usersCountry}`;
      return redirectData.pages.filter((page) => page.languageCode.endsWith(targetCountry));
    }
  },

  initLanguageOptionEvents: function () {
    const $languageOptions = document.querySelectorAll(this.props.selectorLanguageOptions);
    if ($languageOptions) {
      for (let i = 0; i < $languageOptions.length; ++i) {
        let $option = $languageOptions[i];

        // Removed event listeners to avoid duplicates
        const $optionClone = $option.cloneNode(true);
        $option.parentElement.replaceChild($optionClone, $option);
        $option = $optionClone;

        $option.addEventListener("change", () => {
          const isTranslationEnabledLanguage = JSON.parse($option.dataset.translationEnabled || "false");
          if (isTranslationEnabledLanguage) {
            sessionStorage.setItem(bcl.s.translateOnTheFly.props.sessionStorageEnabledLanguageProp, $option.value);
            bcl.s.translateOnTheFly.initTranslate(document.documentElement.lang, $option.value);
          } else {
            sessionStorage.removeItem(bcl.s.translateOnTheFly.props.sessionStorageEnabledLanguageProp);
            window.location.href = $option.value;
          }
        });
      }
    }
  },
  updateSelectedTranslation: function () {
    const translationEnabledLanguage = sessionStorage.getItem(bcl.s.translateOnTheFly.props.sessionStorageEnabledLanguageProp);
    if (translationEnabledLanguage) {
      const $translationEnabledLanguageOption = document.querySelector(`.formLanguageContainer-JS input[value="${translationEnabledLanguage}"]`);
      if ($translationEnabledLanguageOption) {
        $translationEnabledLanguageOption.checked = true;
        document.querySelector(".language-current-JS span").textContent = $translationEnabledLanguageOption.dataset.label;
      }
    }
  },
};

export default language;
